import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig/firebase";
import { useAccessLevel } from "./useAccessLevel";
// Asegúrate de importar las funciones necesarias de Firebase

export const useIncrementFilesDown = () => {
  const { canAccess } = useAccessLevel();

  const incrementFilesDown = async (id) => {
    const docRef = doc(db, "recursos", id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      // Verificar nivel de acceso
      if (canAccess(data.nivelAcceso || 0)) {
        const filesDown = parseInt(data.descargas, 10) || 0;
        await updateDoc(docRef, { 
          descargas: (filesDown + 1).toString() 
        });
      }
    }
  };

  return { incrementFilesDown };
};
